import React, { useMemo, useState } from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { FiEye } from "react-icons/fi";
import { APP } from "../../components/mobileUi";
import { htmlToPlainText } from "./trainingConstants";

const MUTED = "#64748B";
const BORDER = "rgba(8, 20, 45, 0.10)";

// Gradient xanh dương của app (themes primary2 = ["#68A2FF", "#2168DA"], ngang:
// đậm bên trái -> nhạt bên phải).
const APP_GRADIENT = "linear-gradient(to right, #2168DA, #68A2FF)";

// Nút primary gradient xanh (khớp GradientButton primary2 của app).
export const GradientButton = ({ children, ...props }) => (
  <Button
    w="100%"
    h="48px"
    bgImage={APP_GRADIENT}
    color="white"
    fontWeight={700}
    fontSize="15px"
    _hover={{ bgImage: APP_GRADIENT, opacity: 0.92 }}
    _active={{ opacity: 0.85 }}
    _disabled={{ opacity: 0.5, cursor: "not-allowed" }}
    {...props}
  >
    {children}
  </Button>
);

// Nút xanh đặc (khớp nút "Đóng" ở popup kết quả của app: colors.tabActive).
export const SolidBlueButton = ({ children, ...props }) => (
  <Button
    w="100%"
    h="48px"
    bg={APP.tabActive}
    color="white"
    fontWeight={700}
    fontSize="15px"
    _hover={{ bg: APP.tabActive, opacity: 0.92 }}
    _active={{ opacity: 0.85 }}
    {...props}
  >
    {children}
  </Button>
);

// Nút phụ viền xám trung tính (khớp "Quay lại"/"Hủy" của app).
export const NeutralButton = ({ children, ...props }) => (
  <Button
    w="100%"
    h="48px"
    bg="white"
    color="#18212F"
    fontWeight={700}
    fontSize="15px"
    border="1px solid"
    borderColor="#CBD5E1"
    _hover={{ bg: "#F7F9FC" }}
    _active={{ bg: "#EEF1F6" }}
    {...props}
  >
    {children}
  </Button>
);

// Nút bo góc ở góc phải thẻ: "Xem" (kèm icon mắt) hoặc "Học ngay".
export const ActionPill = ({ label = "Xem", icon = <FiEye /> }) => (
  <Flex
    align="center"
    gap="6px"
    bg={APP.tabActive}
    color="white"
    px="16px"
    py="9px"
    borderRadius="8px"
    fontSize="13px"
    fontWeight={700}
    flexShrink={0}
  >
    {icon}
    {label}
  </Flex>
);

// Thẻ trắng bo góc dùng chung cho chủ đề / bài giảng / bài học.
export const CardBox = ({ onClick, children, ...props }) => (
  <Box
    onClick={onClick}
    cursor={onClick ? "pointer" : "default"}
    bg="white"
    border="1px solid"
    borderColor={BORDER}
    borderRadius="12px"
    p="14px"
    {...props}
  >
    {children}
  </Box>
);

// Ô icon vuông bo góc trước tiêu đề thẻ (nền xanh nhạt + icon xanh).
export const CardHeaderIcon = ({ icon }) => (
  <Flex
    w="28px"
    h="28px"
    borderRadius="8px"
    bg="#EFF6FF"
    align="center"
    justify="center"
    flexShrink={0}
    color={APP.tabActive}
    fontSize="16px"
  >
    {icon}
  </Flex>
);

// Mô tả (HTML -> text thuần) cắt 3 dòng kèm "Xem thêm > / Thu gọn" (khớp app).
export const ClampDescription = ({ html, lines = 3 }) => {
  const [expanded, setExpanded] = useState(false);
  const text = useMemo(() => htmlToPlainText(html), [html]);
  if (!text) return null;

  return (
    <Box>
      <Text
        fontSize="14px"
        color={MUTED}
        lineHeight="20px"
        whiteSpace="pre-line"
        sx={
          expanded
            ? undefined
            : {
                display: "-webkit-box",
                WebkitLineClamp: `${lines}`,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }
        }
      >
        {text}
      </Text>
      <Box
        as="button"
        type="button"
        mt="6px"
        fontSize="14px"
        fontWeight={600}
        color={APP.tabActive}
        onClick={(e) => {
          e.stopPropagation();
          setExpanded((v) => !v);
        }}
      >
        {expanded ? "Thu gọn" : "Xem thêm >"}
      </Box>
    </Box>
  );
};
